export interface GallerySlide {
  src: string
  alt: string
  title: string
  caption: string
}

const IMG_BASE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/b9dcc67f-9894-4323-9fab-752184f8f465/product-uploads/'

export const insideItems: string[] = [
  'Studio setup & essential tools',
  'Parts of the sewing machine',
  'Threading & bobbin winding',
  'Needle & thread charts',
  'Tension & stitch settings',
  'Fibers, weaves & knits',
  'Fabric grain & selvage',
  'Hand stitches & seam types',
  'Seam finishes',
  'Body measurement map',
  'Ease & size charts',
  'Pattern symbols & labeling',
  'Skirt, bodice & sleeve blocks',
  'Trouser block drafting',
  'Dart manipulation',
  'Collars, sleeves & cuffs',
  'Draping on the dress form',
  'Reading wrinkles & fitting',
  'Pattern grading',
  'Layout & cutting rules',
  'Waistbands & pockets',
  'Zippers step by step',
  'Buttonholes & closures',
  'Linings & hems',
  'Tailored collar & lapel',
  'Pressing by fabric',
  'Alterations & repairs',
  '4-step demonstration method',
  '❌/✅ comparisons',
  'Teaching cues, drills & quick checks',
]

/** Carousel slides — one real page per volume (Vol 1 to Vol 6). */
export const gallerySlides: GallerySlide[] = [
  {
    src: `${IMG_BASE}mcp_3be2d5dc-4422-4ea4-883f-58170f20e480_1793815150111.jpg`,
    alt: 'Sewing & Pattern Making Instructor Atlas — Vol 1 page: Parts of the Sewing Machine, labeled machine diagram',
    title: 'Vol 1 — Parts of the Sewing Machine',
    caption: 'Vol 1 — Sewing Fundamentals, Tools, Fabrics & Machine Techniques: a labeled machine diagram, a common mistake, an instructor cue and a drill.',
  },
  {
    src: `${IMG_BASE}mcp_3be2d5dc-4422-4ea4-883f-58170f20e480_1793815152835.jpg`,
    alt: 'Sewing & Pattern Making Instructor Atlas — Vol 2 page: Pattern Symbols, grainline, notches and markings explained',
    title: 'Vol 2 — Pattern Symbols',
    caption: 'Vol 2 — Pattern Making, Body Measurements & Garment Drafting: the essential pattern symbols explained, an instructor cue, a drill and a quick check.',
  },
  {
    src: `${IMG_BASE}mcp_3be2d5dc-4422-4ea4-883f-58170f20e480_1793815155722.jpg`,
    alt: 'Sewing & Pattern Making Instructor Atlas — Vol 3 page: Preparing the Dress Form, applying style tape to the key lines',
    title: 'Vol 3 — Preparing the Dress Form',
    caption: 'Vol 3 — Advanced Pattern Making, Draping & Garment Fitting: style-tape lines on the dress form, ❌/✅, an instructor cue and a draping drill.',
  },
  {
    src: `${IMG_BASE}mcp_3be2d5dc-4422-4ea4-883f-58170f20e480_1793815158518.jpg`,
    alt: 'Sewing & Pattern Making Instructor Atlas — Vol 4 page: Centered Zipper, step-by-step sequence with stitching distances',
    title: 'Vol 4 — Centered Zipper',
    caption: 'Vol 4 — Garment Cutting, Assembly & Construction Techniques: the centered zipper step by step, exact stitching distances, ❌/✅ and a 20-minute drill.',
  },
  {
    src: `${IMG_BASE}mcp_3be2d5dc-4422-4ea4-883f-58170f20e480_1793815161315.jpg`,
    alt: 'Sewing & Pattern Making Instructor Atlas — Vol 5 page: Tailored Collar & Lapel construction',
    title: 'Vol 5 — Tailored Collar & Lapel',
    caption: 'Vol 5 — Professional Tailoring, Finishing Techniques & Garment Alterations: tailored collar and lapel construction, ❌/✅ and an instructor cue.',
  },
  {
    src: `${IMG_BASE}mcp_3be2d5dc-4422-4ea4-883f-58170f20e480_1793815163957.jpg`,
    alt: 'Sewing & Pattern Making Instructor Atlas — Vol 6 page: The 4-Step Demonstration Method for teaching any sewing skill',
    title: 'Vol 6 — The 4-Step Demonstration Method',
    caption: 'Vol 6 — Sewing Instruction, Teaching Programs & Practical Assessments: a 4-step sequence for teaching any sewing skill, an instructor cue and a practice drill.',
  },
]
